import { create } from "zustand";

type AdminUser = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  organizationId: number;
  isDemo: boolean;
  role: string;
  hasAdminPanelAccess: boolean;
  customSnippetsUrl: string | null;
};

type AdminStore = {
  user: AdminUser | null;
  setUser: (user: AdminUser) => void;
  setCustomSnippetsUrl: (customSnippetsUrl: string | null) => void;
  clearUser: () => void;
};

export const useAdminStore = create<AdminStore>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  setCustomSnippetsUrl: (customSnippetsUrl) =>
    set((state) => (state.user ? { user: { ...state.user, customSnippetsUrl } } : state)),
  clearUser: () => set({ user: null })
}));
